/*!
 * 1DS JS SDK Properties plugin, 2.4.7
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* User.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
import { cookieAvailable, getCookie, objDefineAccessors, CoreUtils } from '@microsoft/1ds-core-js';
import * as Utils from '../Utils';
var User = /** @class */ (function () {
    function User(coreConfig, propertiesConfig, logger) {
        this._logger = logger;
        //Add MUID in user localId
        if (!coreConfig.disableCookiesUsage && cookieAvailable()) {
            var muidValue = getCookie('MUID');
            if (muidValue) {
                this.setLocalId('t:' + muidValue);
            }
            if (propertiesConfig.enableApplicationInsightsUser) {
                // get userId or create new one if none exists
                var aiUser = getCookie(User.userCookieName);
                if (aiUser) {
                    var params = aiUser.split(User.cookieSeparator);
                    if (params.length > 0) {
                        this.id = params[0];
                    }
                }
                if (!this.id) {
                    this.id = CoreUtils.newId((coreConfig && !CoreUtils.isUndefined(coreConfig.idLength)) ? coreConfig.idLength : 22);
                    var date = new Date();
                    var acqStr = Utils.toISOString(date);
                    this.accountAcquisitionDate = acqStr;
                    // without expiration, cookies expire at the end of the session
                    // set it to 365 days from now
                    // 365 * 24 * 60 * 60 * 1000 = 31536000000 
                    date.setTime(date.getTime() + 31536000000);
                    var newCookie = [this.id, acqStr];
                    var cookieDomain = propertiesConfig.cookieDomain ? propertiesConfig.cookieDomain : undefined;
                    Utils._setCookie(this._logger, User.userCookieName, newCookie.join(User.cookieSeparator) + ';expires=' + date.toUTCString(), cookieDomain);
                }
            }
        }
        //Add user language
        if (typeof navigator !== 'undefined') {
            var nav = navigator;
            this.locale = nav.userLanguage || nav.language;
        }
    }
    /**
     * The userId as known by the logging library.
     */
    User.prototype.getLocalId = function () {
        if (this._customLocalId) {
            return this._customLocalId;
        }
        var muidValue = getCookie('MUID');
        if (muidValue) {
            this.setLocalId('t:' + muidValue);
        }
        return undefined;
    };
    User.prototype.setLocalId = function (value) {
        this._customLocalId = value;
    };
    User.cookieSeparator = '|';
    User.userCookieName = 'ai_user';
    /**
     * Static constructor, attempt to create accessors
     */
    User._staticInit = (function () {
        // Dynamically create get/set property accessors
        objDefineAccessors(User.prototype, "localId", User.prototype.getLocalId, User.prototype.setLocalId);
    })();
    return User;
}());
export { User };
//# sourceMappingURL=User.js.map